import React, {
  createRef,
  ReactNode,
  useCallback,
  useEffect,
  useState,
} from 'react';

import VersionInfo from '@/components/VersionInfo';

import MedflowLogo from '@/components/Logo/MedflowLogo';
import AuthBanner from '@/assets/banners/login-banner.png';

import {
  Container,
  AuthContainer,
  LogoContainerHeader,
  AuthBox,
  AuthBoxHeader,
  AuthBoxContent,
  AuthBannerContainer,
  AuthBannerLogoContainer,
  AuthLoginBoxContainer,
  AuthBannerImage,
} from './styles';

interface AuthLayoutProps {
  title: string;
  children?: ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  title,
}: AuthLayoutProps) => {
  const ref = createRef<HTMLDivElement>();

  const [isScrolling, setIsScrolling] = useState(false);
  const [isScrollable, setIsScrollable] = useState(false);

  useEffect(() => {
    if (ref.current) {
      setIsScrollable(ref.current.scrollHeight > ref.current.clientHeight);
    }
  }, [ref]);

  const handleContentScroll = useCallback(
    (event: React.UIEvent<HTMLDivElement>) => {
      const {
        currentTarget: { scrollTop },
      } = event;

      setIsScrolling(scrollTop > 0);
    },
    [],
  );

  return (
    <Container>
      <AuthContainer>
        <AuthBannerContainer>
          <AuthBannerImage src={AuthBanner} alt="Auth Banner" />
          <AuthBannerLogoContainer>
            <MedflowLogo color="white" />
            <h1>Protocolos clínicos validados, em poucos cliques.</h1>
          </AuthBannerLogoContainer>
        </AuthBannerContainer>
        <AuthLoginBoxContainer>
          <AuthBox isScrollable={isScrollable} isScrolling={isScrolling}>
            <AuthBoxHeader>
              <LogoContainerHeader>
                <MedflowLogo color="primary" version="primary" />
                <VersionInfo />
              </LogoContainerHeader>

              <h1>{title}</h1>
              <span>Acesse sua conta</span>
            </AuthBoxHeader>
            <AuthBoxContent ref={ref} onScroll={handleContentScroll}>
              {children}
            </AuthBoxContent>
          </AuthBox>
        </AuthLoginBoxContainer>
      </AuthContainer>
    </Container>
  );
};

AuthLayout.defaultProps = {
  children: undefined,
};

export default AuthLayout;
